import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View, Image } from 'react-native'
import styled from 'styled-components/native'
import theme from '../../../styles/theme'

import { Text } from '../Typography'

const Container = styled(View)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
`

const LogoImage = styled(Image)`
  width: 60px;
  height: 60px;
`

class Logo extends PureComponent {
  render () {
    const { appTitle, hasCustomLogo, hasDownloadedCustomLogo } = this.props
    let source = require('../../../assets/logo.png')
    if (hasCustomLogo && hasDownloadedCustomLogo) {
      source = { uri: this.props.filesToDownload['logo.png'] }
    }
    return (
      <Container>
        <LogoImage source={source} />
        {!this.props.hideText && <Text overrides={{ marginLeft: theme.gutterUnit }} size='xxl' proxima white>{appTitle || 'ASCENSION'}</Text>}
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  appTitle: state.game.appTitle,
  hasCustomLogo: state.game.hasCustomLogo,
  hasDownloadedCustomLogo: state.game.hasDownloadedCustomLogo,
  filesToDownload: state.files.filesToDownload
})

export default connect(mapStateToProps, null)(Logo)
